/**
 * Kalendertag YYYY-MM-DD in lokaler Zeit — nicht UTC via Date.toISOString().
 * API/Formulare bleiben bei reinen Strings; dayjs nur für Parsing/Iteration.
 */
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const YMD = 'YYYY-MM-DD'

export function parseYmd(value: string): dayjs.Dayjs {
  return dayjs(value.trim(), YMD, true)
}

/** Gültiger Kalendertag? */
export function isValidYmd(value: string): boolean {
  return parseYmd(value).isValid()
}

/** Lokaler Kalendertag aus Date (Mitternacht lokal). */
export function formatYmdFromDate(d: Date): string {
  return dayjs(d).format(YMD)
}

export function formatYmd(d: dayjs.Dayjs): string {
  return d.format(YMD)
}

export function todayYmd(): string {
  return dayjs().format(YMD)
}

/** Kalendertage addieren; ungültiges Ausgangsdatum → null. */
export function addDaysYmd(value: string, days: number): string | null {
  const d = parseYmd(value)
  if (!d.isValid()) return null
  return d.add(days, 'day').format(YMD)
}

/** Halb-offenes Intervall [from, to) wie Backend/DB — to exklusiv. */
export function enumerateHalfOpen(from: string, to: string): string[] {
  const out: string[] = []
  let cur = parseYmd(from)
  const end = parseYmd(to)
  if (!cur.isValid() || !end.isValid()) return out
  while (cur.isBefore(end)) {
    out.push(cur.format(YMD))
    cur = cur.add(1, 'day')
  }
  return out
}
